import Underline from "@tiptap/extension-underline";
import { useEditor, UseEditorOptions } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Blockquote from "@tiptap/extension-blockquote";
import { Placeholder } from "@tiptap/extensions";
import BubbleMenu from '@tiptap/extension-bubble-menu'
import classNames from "classnames";

export function useSimpleEditor({ placeholder, bubbleMenuElement, additionalExtensions, ...props }: UseEditorOptions & { placeholder?: string; bubbleMenuElement?: HTMLElement; additionalExtensions?: UseEditorOptions["extensions"] }) {
  const blockquoteCx = classNames('')
  return useEditor({
    extensions: [StarterKit.configure({
      code: false,
      codeBlock: false,
      heading: false,
      hardBreak: false,
      orderedList: {
        HTMLAttributes: {
          class: 'list-decimal'
        },
      },
      bulletList: {
        HTMLAttributes: {
          class: 'list-disc'
        }
      },
      listItem: {
        HTMLAttributes: {
          class: 'ml-1',
        },
      },
    }), Blockquote.configure({
      HTMLAttributes: {
        class: 'pl-0.5 border-l-[3px] border-grey'
      }
    }), Underline, Placeholder.configure({
      placeholder,
    }), BubbleMenu.configure({
      element: bubbleMenuElement
    }),
    ...(additionalExtensions ?? [])],
    // content: '<p>Hello World! 🌎️</p>',
    // Don't render immediately on the server to avoid SSR issues
    immediatelyRender: false,
    ...props,
  })
}

